module.exports = __webpack_public_path__ + "img/xuanniao_logo.b8f3031e.png";